/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { Component } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { InjectedFormProps, reduxForm } from 'redux-form';
import { AddressInput } from './types';

export const FORM_NAME = 'addressForm';
const styles = StyleSheet.create({
  form: {
    display: 'inline-block',
    height: '100%',
  },
});

export interface AddressInputFormBaseProps {
  onSubmitSuccess: (address: AddressInput.Address) => void;
}

type AddressInputFormCombinedProps = InjectedFormProps<AddressInput.Address, any, any> & AddressInputFormBaseProps;
class AddressInputForm extends Component<AddressInputFormCombinedProps> {
  render() {
    const { children, handleSubmit, onSubmitSuccess, form } = this.props;
    return (
      <form
        className={css(styles.form)}
        name={form}
        // prevent firing of taskForm onSubmit. React 16 portals propagate events through React tree
        onSubmit={e => {
          e.stopPropagation();
          handleSubmit(onSubmitSuccess)(e);
        }}
      >
        {children}
      </form>
    );
  }
}

export default reduxForm<AddressInput.Address, AddressInputFormBaseProps>({
  form: FORM_NAME,
  enableReinitialize: true,
  initialValues: {},
  // Commenting out below since we don't have access to formUtils
  // onSubmitFail(errors) {
  //   formUtils.focusOnFirstError(errors, addressFields);
  // },
})(AddressInputForm);
